import { Shell, initializeMsal } from '..';
import { ConsoleLogger, Runtime } from '../../shell';
import { TrackingService, TrackingServiceKey } from '../services';
export function createRuntime({ shell = Shell.Business, loggers }) {
    const msalInstance = initializeMsal({ shell });
    msalInstance.initialize();
    const loggerCollection = [new ConsoleLogger()];
    if (loggers)
        loggerCollection.push(...loggers);
    return new Runtime({
        loggers: loggerCollection,
        services: {
            [TrackingServiceKey]: new TrackingService(),
        },
        sessionAccessor: () => {
            return msalInstance;
        },
        shell: shell,
    });
}
